import userGeoLocationConstants from "../constants/userGeoLocationConstants";

const initialState = {
    countryCode: null,
    countryName: null,
    countryCallingCode: null,
    state: null,
    city: null,
    postalCode: null,
}

const userGeoLocationReducer = (state = initialState, action) => {
    switch (action.type) {
        case userGeoLocationConstants.FETCH_USER_GEOLOCATION:
            return {
                ...action.payload
            }

        case userGeoLocationConstants.UPDATE_USER_GEOLOCATION:
            return {
                ...state,
                ...action.payload
            }

        default:
            return state
    }
}

export default userGeoLocationReducer;